export const cssScale = {
  c0: "0",
  c1: "4px",
  c2: "8px",
  c3: "12px",
  c4: "16px",
  c5: "20px",
  c6: "24px",
  c7: "28px",
  c8: "32px",
  c9: "36px",
  c10: "40px",
  c11: "44px",
  c12: "48px",
  c13: "52px",
  c14: "56px",
  c15: "60px",
};

export const defaultFontSize = "14px";

export const boxShadow = `0 6px 14px rgba(0, 0, 0, 0.25),
0 6px 6px rgba(0, 0, 0, 0.22)`
